import React from 'react';

const CertificationDisplay = ({ walletAddress, certs = [] }) => {
  return (
    <div style={{ marginTop: '2rem' }}>
      <h3>Certifications for Wallet:</h3>
      <code>{walletAddress}</code>
      {certs.length === 0 ? (
        <p>No certifications found.</p>
      ) : (
        <ul>
          {certs.map((cert, idx) => {
            const daysLeft = Math.ceil((new Date(cert.expirationDate) - new Date()) / (1000 * 60 * 60 * 24));
            const isExpired = daysLeft <= 0;
            const isExpiringSoon = daysLeft <= 30;

            return (
              <li key={idx} style={{
                backgroundColor: isExpired ? '#ffe5e5' : isExpiringSoon ? '#fffacc' : '#e5ffe5',
                padding: '1rem',
                margin: '1rem 0',
                borderRadius: '10px'
              }}>
                <strong>{cert.name}</strong><br />
                Issued: {cert.issueDate}<br />
                Expires: {cert.expirationDate}<br />
                {isExpired ? <span style={{ color: 'red' }}>Expired</span> :
                  isExpiringSoon ? <span style={{ color: 'orange' }}>Expiring in {daysLeft} days</span> :
                    <span style={{ color: 'green' }}>Valid</span>}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default CertificationDisplay;
